import { z } from 'zod'
import { uuidSchema } from '../validators/uuid.validator.js'

/**
 * A person at a client. Contacts are a separate record even for residential
 * clients, where there is usually only one: it keeps a single shape everywhere,
 * and the people turn over independently of the relationship — an HOA board
 * changes while the HOA stays a client.
 */
export const contactDtoSchema = z.object({
  id: uuidSchema,
  clientId: uuidSchema,
  name: z.string(),
  /** Job title or role, e.g. "Board President", "Property Manager". */
  title: z.string().nullable(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  /** The default person to address a proposal to. At most one per client. */
  isPrimary: z.boolean(),
  notes: z.string().nullable(),
  archivedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
})

export type ContactDto = z.infer<typeof contactDtoSchema>
